<template>
  <div id="filePreview">
    <!-- 头部导航 -->
    <header class="preview-header">
      <div class="header-top">
        <div class="breadcrumb-wrapper">
          <nav class="breadcrumb">
            <span
                class="breadcrumb-item breadcrumb-link"
                @click="goToProject"
                :title="'返回项目首页'"
            >
              <i class="el-icon-arrow-left"></i>
              <span class="link-text">{{ projectName || '项目首页' }}</span>
            </span>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item breadcrumb-link" @click="goToProject">
              {{ documentName || '文档详情' }}
            </span>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item breadcrumb-current">正文</span>
          </nav>
        </div>

        <div class="header-actions">
          <el-button
              class="download-btn"
              size="small"
              icon="el-icon-download"
              @click="downloadFile"
          >
            下载文件
          </el-button>
        </div>
      </div>

      <!-- 文档信息区 -->
      <div class="document-info">
        <h1 class="document-title">{{ documentName || '文件预览' }}</h1>
        <div class="document-meta">
          <div class="meta-item" v-if="formattedCreateTime">
            <i class="el-icon-calendar"></i>
            <span>{{ formattedCreateTime }}</span>
          </div>
          <div class="meta-divider" v-if="formattedCreateTime && author"></div>
          <div class="meta-item author-item" v-if="author">
            <i class="el-icon-user"></i>
            <span>{{ author }}</span>
          </div>
          <div class="meta-divider" v-if="(formattedCreateTime || author) && viewCount"></div>
          <div class="meta-item" v-if="viewCount">
            <i class="el-icon-eye"></i>
            <span>浏览 {{ viewCount }}</span>
          </div>
          <div class="meta-divider" v-if="(formattedCreateTime || author || viewCount) && wordCount"></div>
          <div class="meta-item word-count-item" v-if="wordCount">
            <i class="el-icon-document"></i>
            <span>字数 {{ formattedWordCount }}</span>
          </div>
          <div class="meta-divider" v-if="(formattedCreateTime || author || viewCount || wordCount) && fileExt"></div>
          <div class="meta-item" v-if="fileExt">
            <i class="el-icon-files"></i>
            <span class="file-ext-tag">{{ fileExt.toUpperCase() }}</span>
          </div>
        </div>
      </div>
    </header>

    <!-- 文件预览区域 -->
    <main class="preview-content">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner">
          <div class="spinner-ring"></div>
        </div>
        <p class="loading-text">正在加载文件...</p>
      </div>

      <!-- kkFileView 统一预览（所有文件类型） -->
      <div v-else-if="kkFileViewReady" class="iframe-preview file-preview">
        <div class="preview-frame">
          <iframe
              :src="kkFileViewUrl"
              class="preview-iframe"
              frameborder="0"
              :title="documentName"
              allowfullscreen
          ></iframe>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-container">
        <div class="empty-icon">
          <i class="el-icon-folder-opened"></i>
        </div>
        <h3 class="empty-title">暂无预览文件</h3>
        <p class="empty-desc">该文档没有可预览的文件内容</p>
        <el-button class="empty-btn" size="small" @click="goToProject">返回列表</el-button>
      </div>
    </main>
  </div>
</template>

<script>
let Base64 = require('js-base64').Base64;
import { getDocumentDetail } from '@/request/api.js';

export default {
  name: 'filePreview',
  data() {
    return {
      loading: false,
      documentName: '',
      author: '',
      createTime: '',
      filePath: '',
      documentType: '',
      viewCount: '',
      wordCount: null,
      projectName: '',
      parentProjectId: '',
    }
  },
  computed: {
    decodedFilePath() {
      if (!this.filePath) return ''
      try {
        return decodeURIComponent(this.filePath)
      } catch (e) {
        return this.filePath
      }
    },
    pureFilePath() {
      try {
        return (this.decodedFilePath || '').split('?')[0] || ''
      } catch (e) {
        return ''
      }
    },
    formattedCreateTime() {
      if (!this.createTime) return ''
      try {
        return this.$moment(this.createTime).format('YYYY/MM/DD')
      } catch (e) {
        return this.createTime
      }
    },
    formattedWordCount() {
      if (this.wordCount == null || this.wordCount === '') return ''
      const count = Number(this.wordCount)
      if (isNaN(count)) return this.wordCount
      if (count >= 10000) {
        return (count / 10000).toFixed(1) + '万'
      }
      return count.toLocaleString()
    },
    fileExt() {
      const pure = this.pureFilePath
      const match = pure.match(/\.([a-zA-Z0-9]+)$/)
      return match ? match[1].toLowerCase() : ''
    },
    kkFileViewUrl() {
      if (!this.filePath) return ''
      try {
        // 直接用原始 filePath，保留 Signature 中的 %2B/%3D 百分号编码
        // 不能用 decodedFilePath，decodeURIComponent 会把 %2B→+ %3D→= 破坏 OSS 签名
        const url = this.filePath
        // 1. base64编码
        let base64Str = Base64.encode(url)
        // 2. 去除base64自动生成的 \r \n 换行符（关键修复）
        base64Str = base64Str.replace(/[\r\n]/g, '')
        // 3. 再进行url编码
        const encodeUrl = encodeURIComponent(base64Str)

        let previewUrl = `https://vanmu.life-oasis.com/kkFileView/onlinePreview?url=${encodeUrl}`

        if (this.fileExt === 'pdf') {
          previewUrl += '&officePreviewType=pdf'
        }
        return previewUrl
      } catch (e) {
        console.error('生成预览地址失败', e)
        return ''
      }
    },


    // https://vanmu.life-oasis.com/kkFileView/addTask?url=http://life-oasis.oss-cn-beijing.aliyuncs.com/ai/generate/doc/efbccbfd423f440705eab147dcabbe4b.docx?Expires=1785291643&OSSAccessKeyId=LTAI5tLYp2kUHG4q8X3a2zQq&Signature=y525NkndpEPKN9vMs3KBWtKqN%2Fs%3D


    kkFileViewReady() {
      return !this.loading && !!this.kkFileViewUrl
    }
  },
  created() {
    const documentId = this.$route.query.documentId
    if (documentId) {
      this.fetchDocument(documentId)
    }
  },
  methods: {
    async fetchDocument(documentId) {
      this.loading = true
      try {
        const res = await getDocumentDetail(documentId)
        if (res.code === 200 && res.data) {
          const data = res.data
          this.documentName = data.documentName || ''
          this.author = data.uploader || data.author || data.createBy || ''
          this.createTime = data.createTime || ''
          this.filePath = data.filePath || ''
          this.documentType = data.documentType || ''
          this.projectName = data.projectName || ''
          this.parentProjectId = data.parentProjectId || ''
          this.viewCount = data.viewCount || ''
          this.wordCount = data.wordCount != null ? data.wordCount : null
          // 设置页面标题
          document.title = this.documentName
              ? `${this.documentName} - 文件预览`
              : '文件预览'
        } else {
          this.$message.error(res.msg || '获取文档信息失败')
        }
      } catch (e) {
        console.error('获取文档详情失败', e)
        this.$message.error('获取文档信息失败')
      } finally {
        this.loading = false
      }
    },
    goToProject() {
      if (this.parentProjectId) {
        window.location.href = `https://zhjs.article.life-oasis.com/project/${this.parentProjectId}`
      }
    },
    downloadFile() {
      if (this.decodedFilePath) {
        window.open(this.decodedFilePath, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#filePreview {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

// ========== 头部导航 ==========
.preview-header {
  flex-shrink: 0;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  padding: 0 32px;
  border-bottom: 1px solid #ebeef5;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409eff, #73b8ff, #409eff);
  }
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  border-bottom: 1px solid #f0f2f5;
}

.breadcrumb-wrapper {
  flex: 1;
  min-width: 0;
}

.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #646a73;

  .breadcrumb-item {
    display: flex;
    align-items: center;

    &.breadcrumb-link {
      color: #409eff;
      cursor: pointer;
      transition: all 0.2s ease;
      padding: 3px 6px;
      border-radius: 4px;

      &:hover {
        color: #66b1ff;
        background: rgba(64, 158, 255, 0.06);
      }

      i {
        font-size: 14px;
        margin-right: 6px;
        color: #8c939d;

        &:hover {
          color: #409eff;
        }
      }

      .link-text {
        margin-left: 2px;
      }
    }

    &.breadcrumb-current {
      color: #303133;
      font-weight: 500;
    }
  }

  .breadcrumb-separator {
    margin: 0 8px;
    color: #dcdfe6;
    font-size: 12px;
  }
}

.header-actions {
  flex-shrink: 0;

  .download-btn {
    background: #409eff;
    border: none;
    color: #fff;
    padding: 8px 20px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: #66b1ff;
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
      transform: translateY(-1px);
    }

    &:active {
      background: #3a8ee6;
      transform: translateY(0);
    }
  }
}

// ========== 文档信息区 ==========
.document-info {
  padding: 18px 0 20px;

  .document-title {
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 14px 0;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 800px;
    position: relative;
    padding-left: 16px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 4px;
      bottom: 4px;
      width: 4px;
      background: linear-gradient(180deg, #409eff, #73b8ff);
      border-radius: 2px;
    }
  }

  .document-meta {
    display: flex;
    align-items: center;
    gap: 18px;
    font-size: 13px;
    color: #909399;

    .meta-item {
      display: flex;
      align-items: center;
      gap: 5px;
      transition: color 0.2s ease;

      i {
        font-size: 14px;
        color: #b1b3b8;
        transition: color 0.2s ease;
      }
    }

    .author-item {
      color: #606266;
      font-weight: 500;

      i {
        color: #409eff;
      }
    }

    .word-count-item {
      color: #409eff;

      i {
        color: #409eff;
      }

      span {
        font-weight: 500;
      }
    }

    .file-ext-tag {
      background: linear-gradient(135deg, #f0f2f5, #e8eaed);
      padding: 2px 10px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;
      color: #606266;
      letter-spacing: 0.5px;
    }

    .meta-divider {
      width: 1px;
      height: 14px;
      background: #e4e7ed;
      flex-shrink: 0;
    }
  }
}

// ========== 预览内容区域 ==========
.preview-content {
  flex: 1;
  position: relative;
  margin: 16px 24px 24px;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
}

// ========== 加载状态 ==========
.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafbfc;

  .loading-spinner {
    width: 48px;
    height: 48px;
    position: relative;
    margin-bottom: 18px;

    .spinner-ring {
      position: absolute;
      width: 100%;
      height: 100%;
      border: 3px solid #ebeef5;
      border-top-color: #409eff;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    &::after {
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      right: 4px;
      bottom: 4px;
      border: 3px solid transparent;
      border-top-color: #a0cfff;
      border-radius: 50%;
      animation: spin 0.7s linear infinite reverse;
    }

    &::before {
      content: '';
      position: absolute;
      top: -6px;
      left: -6px;
      right: -6px;
      bottom: -6px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(64, 158, 255, 0.12) 0%, transparent 70%);
      animation: pulse-glow 2s ease-in-out infinite;
    }
  }

  .loading-text {
    font-size: 14px;
    color: #909399;
    margin: 0;
    letter-spacing: 0.5px;
  }
}

@keyframes pulse-glow {
  0%, 100% {
    opacity: 0.4;
    transform: scale(0.9);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

// ========== iframe预览（kkFileView统一预览） ==========
.iframe-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .preview-frame {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .preview-iframe {
    width: 100%;
    height: 100%;
    border: none;
    background: #ffffff;
  }
}

// ========== 空状态 ==========
.empty-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafbfc;

  .empty-icon {
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ecf5ff;
    border-radius: 50%;
    margin-bottom: 20px;

    i {
      font-size: 36px;
      color: #409eff;
    }
  }

  .empty-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 8px 0;
  }

  .empty-desc {
    font-size: 13px;
    color: #909399;
    margin: 0 0 24px 0;
  }

  .empty-btn {
    background: #ecf5ff;
    color: #409eff;
    border: none;
    padding: 8px 24px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: #409eff;
      color: #fff;
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
      transform: translateY(-1px);
    }
  }
}

// ========== 响应式适配 ==========
@media screen and (max-width: 768px) {
  .preview-header {
    padding: 0 16px;
  }

  .header-top {
    height: 48px;
  }

  .breadcrumb {
    font-size: 13px;
  }

  .document-title {
    font-size: 17px;
    max-width: 100%;
    padding-left: 12px;

    &::before {
      width: 3px;
    }
  }

  .document-meta {
    flex-wrap: wrap;
    gap: 10px;
  }

  .preview-content {
    margin: 8px;
    border-radius: 8px;
  }
}
</style>

